module.exports = __webpack_public_path__ + "static/media/app_service_plans.3420af9a.svg";